<template>
  <v-container fluid>
    <div v-if="selected_comunidad < 1">
      <v-alert
        dense
        text
        type="info"
        transition="fade-transition"
      >
        Por favor seleccione una <strong>Comunidad</strong>
      </v-alert>
    </div>

    <div v-if="showImportPedido">
    <h4 class="mb-1"><v-icon right>mdi-file-document-edit-outline</v-icon> Ámbito Territorial</h4>
    <AmbitoTerritorial></AmbitoTerritorial>
    </div>
    <div v-if="selected_comunidad > 0 && showImportPedido">
      <v-alert
        dense
        text
        type="info"
        v-if="tipo_pedido === null"
      >
        Por favor indique si el pedido será <strong>Importado</strong>
      </v-alert>
    <h4 class="mb-1"><v-icon right>mdi-file-document-edit-outline</v-icon> Tipo de Pedido</h4>
    <v-row>
        <v-col md="12" sm="12">
          <v-autocomplete
            v-model="tipo_pedido"
            label="Tipo Pedido"
            item-text="name"
            item-value="id"
            :items="dataTipoPedidos"
            :disabled="tipo_pedido !== null"
            @change="showPedidosImport"
          >
          </v-autocomplete>
        </v-col>
      </v-row>
    </div>

      <pedidos-import
        ref="pedidosImportExcel"
        v-if="tipo_pedido === 2"
        @hiddenImportFalse ="hiddenImport()"
      ></pedidos-import>

     <v-form ref="entryPedido" v-if="tipo_pedido === 1 && selected_comunidad > 0">

    <h4 class="mb-1"><v-icon right>mdi-file-document-edit-outline</v-icon> Jefes de Hogares</h4>
    <JefesHogarTable ref="jefes_hogar_table" :entrys="getEntryData" @calculateCilindro="getValidStepPedido"/>


    <v-row>
      <v-col md="12" sm="12" class="mb-4">
        <h4 class="mb-1"><v-icon right>mdi-file-document-edit-outline</v-icon> Pagos por Verificar</h4>
        <v-data-table
          :headers="headers"
          :items="pagos"
          class="elevation-1"
        >
          <template v-slot:item.fecha_pago="{ item }">
            {{ item.fecha_pago | moment("DD/MM/YYYY") }}
         </template>
         <template v-slot:item.monto="{ item }">
          {{ formatCurrency(item.monto) }} Bs.
         </template>
        </v-data-table>
      </v-col> 
    </v-row>

    <v-row>
      <v-col md="6" sm="12">

        <ResumenTotalesPedidos
          ref="resumen_totales_pedidos"
          :totalCilindros="getTotalCilindros"
          :totalPagar="getTotalPagar"
          :jefeComunidadName="getJefeComunidadName"
          :comunidadName="getComunidadName"
          :dateOrder="getDateOrder"
        >

        </ResumenTotalesPedidos>
      </v-col>

       <v-col md="6" sm="12">
        <AgregarPagosPedidos @addNewPago="addNewPago"></AgregarPagosPedidos>
       </v-col>
    </v-row>
    <div>
      
      <v-row>
        <v-col md="12" sm="12">
          <v-checkbox
            v-model="extra_verify"
            color="red"
            label="Requiere verificación por Operador de Caja ya que hace falta un pago en efectivo y/o cualquier otro metodo de pago."
          ></v-checkbox>
        </v-col>
      </v-row>
    </div>

    <div class="flex-grow-1"></div>
      <v-row>
        <v-col md="12" sm="12" class="text-center mt-4">
          <v-btn
            color="blue darken-1 white--text"
            @click="add()"
            :loading="loadingSave"
            :disabled="loadingSave"
          >
            <v-icon right>mdi-content-save</v-icon>
            <v-divider class="mx-4" inset vertical></v-divider>
            Guardar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex"
import JefesHogarTable from "@/components/table/JefesHogar"
import AmbitoTerritorial from "@/components/territorio/AmbitoTerritorial.vue"
import HTTP from "@/http"
import messageMixin from "@/mixins/common"
import ConfirmacionPedidoResumen from "@/components/resumen/ConfirmacionPedido"
import ResumenTotalesPedidos from "@/components/pedidos/ResumenTotalesPedidos.vue"
import AgregarPagosPedidos from "@/components/pedidos/AgregarPagosPedidos.vue"
import PedidosImport from "@/components/importexcel/PedidosImport.vue"

export default {
  name: "pedidos-create",
  mixins: [messageMixin],
  components: {
    JefesHogarTable,
    AmbitoTerritorial,
    ConfirmacionPedidoResumen,
    ResumenTotalesPedidos,
    AgregarPagosPedidos,
    PedidosImport
},

  data() {
    return {
      dataTipoPedidos: [
        {
          id: 1,
          name: "Manual"
        },
        {
          id: 2,
          name: "Importar"
        }
      ],
      tipo_pedido: null,
      validStepPedido: false,
      totalCilindros: 0,
      totalPagar: 0,
      jefeComunidadName: null,
      comunidadName: null,
      loading: false,
      loadingSave: false,
      extra_verify: false,
      showImportPedido:true,
      pagos: [],
      headers: [
        {
          text: "FECHA DE PAGO",
          value: "fecha_pago",
          align: "center",
        },
         {
          text: "CÓDIGO DE PAGO",
          value: "codigo",
          align: "center",
        },

         {
          text: "TIPO DE PAGO",
          value: "tps_modalidad_pago.nombre",
          align: "center",
        },
         {
          text: "METODO DE PAGO",
          value: "metodo_pago.tipo",
          align: "center",
        },
        {
          text: "BANCO",
          value: "dts_cuentas.descripcion",
          align: "center",
        },
        {
          text: "MONTO DE PAGO",
          value: "monto",
          align: "center",
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
    }
  },

  mounted() {
    this.setEntrys([]);
    this.setSelectedComunidad(null);
    this.setComunidades([]);
  },

  methods: {
    ...mapActions("Persona", ["getEntryActive", "getEntryActiveCommunity"]),
    ...mapActions("Pedidos", ["createEntry", "createPedido"]),
    ...mapMutations("Pedidos", ["toggleEntrysDialog", "setDetail", "setEntrys"]),
    ...mapMutations("Comunidades", [
      "setSelectedComunidad",
      "setComunidades",
    ]),
  
    close() {
      this.setDetail(null)
      this.toggleEntrysDialog({ editMode: false })
    },

    hiddenImport() {
      this.showImportPedido = false;
    },

    showPedidosImport() {
      if (this.tipo_pedido === 2) {
        console.log('====================')
        console.log(this.$refs.pedidosImportExcel.showImport)
        this.$refs.pedidosImportExcel.showImport = true;
      }
    },
    
    addNewPago(data) {
      if (this.selected_comunidad === null || this.selected_comunidad === 0) {
        this.$swal.fire({
          title: "Comunidad es Requeridad",
          text: "Debes seleccionar la comunidad e indicar los cilindros a comprar.",
          icon: 'error',
        });
        return false;
      }

      if (Number(this.detail.total) === 0 || this.totalPagar ===0) {
        this.$swal.fire({
          title: "No se ha encontrado deuda",
          text: "Debes seleccionar los cilindos a comprar de cada jefe de hogar.",
          icon: 'error',
        });
        return false;
      }

      if (Number(this.detail.total) === 0 || this.totalPagar ===0) {
        this.$swal.fire({
          title: "No se ha encontrado deuda",
          text: "Debes seleccionar los cilindos a comprar de cada jefe de hogar.",
          icon: 'error',
        });
        return false;
      }

      if ( data.tps_modalidad_pago === null ) {
        this.$swal.fire({
          title: "La cuenta bancaria es Requerida",
          text: "Por favor seleccionar la cuenta donde ha realizado el pago.",
          icon: 'error',
        });
        return false;
      }

      if ( data.metodo_pago === null ) {
        this.$swal.fire({
          title: "Metodo de Pago es Requerido",
          text: "Por favor seleccione el metodo de pago utilizado.",
          icon: 'error',
        });
        return false;
      } 

      if ( data.fecha_pago === null ) {
        this.$swal.fire({
          title: "Fecha de pago",
          text: "Seleccione la fecha de pago.",
          icon: 'error',
        });
        return false;
      } 
      let newPago = {
        fecha_pago: data.fecha_pago,
        codigo : data.codigo,
        tps_modalidad_pago : data.tps_modalidad_pago,
        metodo_pago : data.metodo_pago,
        dts_cuentas : data.dts_cuentas,
        monto : data.monto,
      };

      this.pagos.push(newPago);
    },

    async add() {

      if ( this.totalPagar < 6 ) {
        this.$swal.fire({
          title: "El Monto no supera la expectativa",
          text: "Debes agregar los cilindros correspondientes al pedido.",
          icon: 'error',
        });
        return false;
      } 

       // Si no han agregado pago
      if (this.pagos.length === 0 ) {
        this.$swal.fire({
          title: "No se encontraron pagos registrados",
          text: "Debes agregar los pagos correspondientes al pedido.",
          icon: 'error',
        });
        return false;
      }

      const entryData = this.entrys.map((entry) => {
        return entry.dts_bombonas_hogars.map((dts_bombonas_hogar) => ({
          numero_ref: null,
          dts_persona: dts_bombonas_hogar.dts_persona,
          tps_bombonas: dts_bombonas_hogar.tps_bombonas.id,
          cantidad: dts_bombonas_hogar.cantidad_pedido || 0,
        }))
      })

      this.loadingSave = true
      const isOperador =
        [
          this.$store.state.TypeRole.OPERADOR_VENTAS,
        ].includes(this.role) && this.selected_comunidad > 0

      let data = []

      data["entryData"] = entryData
      data["pagos"] = this.pagos
      data["comunidad"] = isOperador ? this.selected_comunidad : null
      data["extra_verify"] = this.extra_verify;
      this.createPedido(data).then((response) => {
        this.loadingSave = false

        if (response === true) {
          this.saveMessage("Pedido");
          this.$router.push('/pedidos/entry');
        } else {
          this.errorMessage(this.messageError)
        }
       
      })
    },
    getJefesHogar() {
      if (
        [
          this.$store.state.TypeRole.OPERADOR_VENTAS,
        ].includes(this.role) &&
        this.selected_comunidad > 0
      ) {
        this.getEntryActiveCommunity(this.selected_comunidad)
        this.comunidadName = this.getAllComunidades.filter(
          (item) => item.id === this.selected_comunidad,
        )[0].nombre
        return
      }

      this.getEntryActive()    
    },

     getValidStepPedido() {
      let isValid = true
      let codes = []
      let weightName = null
      let totalOrderQuantity = 0

      //if (!this.detail) {
      this.totalCilindros = 0
      this.totalPagar = 0
      let cilindrosCantidad = []

      this.entrys.forEach((entry) => {
        totalOrderQuantity = 0
                  
        entry.dts_bombonas_hogars.forEach((dts_bombonas_hogar) => {
           console.log(dts_bombonas_hogar.tps_bombonas.precio);
          const orderQuantity = Number(dts_bombonas_hogar.cantidad_pedido)

          if (orderQuantity > 0) {
            totalOrderQuantity += orderQuantity

            this.totalCilindros += orderQuantity
            this.totalPagar +=
              orderQuantity * Number(dts_bombonas_hogar.tps_bombonas.precio)
            weightName = dts_bombonas_hogar.tps_bombonas.peso

            if (cilindrosCantidad[weightName]) {
              cilindrosCantidad[weightName] += orderQuantity
            } else {
              cilindrosCantidad[weightName] = orderQuantity
            }
          }
        })
      })

      this.setDetail({
        cilindros: cilindrosCantidad,
      })
      //}

      this.validStepPedido = isValid

      //const resultValited = (isValid && this.totalCilindros > 0)

      return true
    },
  },
  computed: {
    ...mapState(["TypeRole"]),
    ...mapGetters("Auth", ["role"]),
    ...mapState("Pedidos", [
      "entry",
      "valid_save",
      "messageError",
      "detail",
    ]),
    ...mapGetters("Pedidos", [
      "entryForEdit",
      "entrysDialogEditMode",
      "entryDialog",
      "statusValidSave",
      "getDisabledRegister",
    ]),
    ...mapState("Persona", ["entrys"]),
    ...mapGetters("JefeComunidad", ["getEnableOrder"]),
    ...mapState("Comunidades", ["selected_comunidad"]),
    ...mapGetters("Comunidades", ["getAllComunidades"]),
    entrysDialog: {
      get() {
        return this.entryDialog
      },
      set() {
        this.close()
      },
    },
   
    getEntryData() {
       if (Number(this.selected_comunidad) > 0) {
        if (!this.entrysDialogEditMode) return this.entrys

        return this.entry
       }
       return [];
    },
    getTotalCilindros() {
      return this.detail && this.detail.cantidad
        ? Number(this.detail.cantidad)
        : this.totalCilindros
    },
    getTotalPagar() {
      return this.detail && this.detail.total
        ? Number(this.detail.total)
        : this.totalPagar
    },
    getJefeComunidadName() {
      if (
        [this.$store.state.TypeRole.OPERADOR].includes(this.role) &&
        this.selected_comunidad > 0
      ) {
        return this.jefeComunidadName
      }

      return this.detail && this.detail.usuario
        ? this.detail.usuario
        : this.jefeComunidadName
    },
    getComunidadName() {
      if (
        [this.$store.state.TypeRole.OPERADOR].includes(this.role) &&
        this.selected_comunidad > 0
      ) {
        return this.comunidadName
      }

      return this.detail && this.detail.comunidad
        ? this.detail.comunidad
        : this.comunidadName
    },
    getDateOrder() {
      return this.detail && this.detail.fecha
        ? new Date(this.detail.fecha)
        : new Date()
    },
  },
  watch: {
    async selected_comunidad() {
      this.loading = true
      this.search = ""
      if (Number(this.selected_comunidad) > 0) {
        this.getJefesHogar();
         this.pagos = [];
      }
    },
  },
}
</script>